module.exports = {
	"id": "AD",
	"name": "Andorra",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.020283,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.013522,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.013522,
			"30": null,
			"31": 0.06761,
			"32": 0.006761,
			"33": 0.006761,
			"34": 0.006761,
			"35": 0.081132,
			"36": 0.027044,
			"37": null,
			"38": 0.013522,
			"39": null,
			"40": 0.020283,
			"41": 0.020283,
			"42": null,
			"43": 0.074371,
			"44": 0.047327,
			"45": 0.013522,
			"46": 0.040566,
			"47": 0.013522,
			"48": 0.013522,
			"49": 2.035061,
			"50": 0.148742,
			"51": 0.655817,
			"52": 0.466509,
			"53": 19.491963,
			"54": 4.766505,
			"55": 0.047327,
			"56": 0.013522,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.081132,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.047327,
			"38": 0.040566,
			"39": 0.006761,
			"40": null,
			"41": 0.013522,
			"42": 0.006761,
			"43": 0.060849,
			"44": 0.027044,
			"45": 0.060849,
			"46": 0.101415,
			"47": 0.358333,
			"48": 2.43396,
			"49": 10.587726,
			"50": 0.06761,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.013522,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.006761,
			"38": 0.087893,
			"39": null,
			"40": 0.216352,
			"41": 0.006761,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.006761
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.074371,
			"6": 0.013522,
			"7": 0.087893,
			"8": 0.54088,
			"9": 0.750471,
			"10": 11.040713,
			"3.1": null,
			"3.2": null,
			"5.1": 0.236635,
			"6.1": 0.209591,
			"7.1": null,
			"9.1": 4.644807
		},
		"ios_saf": {
			"8": 0,
			"10": 8.2385989642,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.222020708993,
			"8.1-8.4": 0.410173852206,
			"9.0-9.2": 0.195679268943,
			"9.3": 2.98536320566
		},
		"android": {
			"3": 0,
			"4": 0.0313927028424,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0039240878553,
			"4.1": 0.113237963824,
			"4.2-4.3": 0.283094909561,
			"4.4": 0.649156248062,
			"4.4.3-4.4.4": 0.654762087855
		},
		"ie": {
			"6": null,
			"7": 0.013522,
			"8": 0.13522,
			"9": 0.317767,
			"10": 0.121698,
			"11": 2.934274,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00558252613168,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000155070170324
		},
		"edge": {
			"12": 0.027044,
			"13": 0.574685,
			"14": 1.392766
		},
		"ie_mob": {
			"10": 0.0223467605634,
			"11": 0.0909832394366
		},
		"bb": {
			"7": 0.001619,
			"10": null
		},
		"samsung": {
			"0": 2.483546
		},
		"and_uc": {
			"0": 0.022666
		},
		"op_mini": {
			"0": 0.075212403698
		},
		"and_chr": {
			"0": 17.237622
		},
		"and_ff": {
			"0": 0.035618
		}
	},
	"total": 99.236279
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AD.json
 ** module id = 455
 ** module chunks = 0
 **/